import { useState } from "react"
import SalaryTemplateForm from "./SalaryTemplateForm";
import SalaryTemplateView from "./SalaryTemplateView";


const SalaryTemplate = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

return (
  <>
    {fromIsShown ? (
        <SalaryTemplateForm addForm={setFromIsShown} update={upData} />
      ) : (
        <SalaryTemplateView addForm={setFromIsShown} update={setUpData} />
      )}

  </>
)
}
export default SalaryTemplate